import React from 'react';
import { AppDispatch } from '../../../store/store';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TeacherLibrary from '../components/TeacherLibrary';

export interface TeacherLibraryProps {}

const TeacherClassroomLibrary = ({}: TeacherLibraryProps) => {
  const dispatch: AppDispatch = useDispatch();
  const navigateTo = useNavigate();

  return (
    <div className="min-h-[calc(100vh-10rem)] flex w-full">
      <TeacherLibrary></TeacherLibrary>
    </div>
  );
};

export default TeacherClassroomLibrary;
